var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 6,
    viewBox: "0 0 20 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.38095 0.619141C1.06809 0.619141 0 1.68723 0 3.00009C0 4.31295 1.06809 5.38104 2.38095 5.38104C3.69381 5.38104 4.7619 4.31295 4.7619 3.00009C4.7619 1.68723 3.69381 0.619141 2.38095 0.619141Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99814 0.619141C8.68528 0.619141 7.61719 1.68723 7.61719 3.00009C7.61719 4.31295 8.68528 5.38104 9.99814 5.38104C11.311 5.38104 12.3791 4.31295 12.3791 3.00009C12.3791 1.68723 11.311 0.619141 9.99814 0.619141Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6153 0.619141C16.3025 0.619141 15.2344 1.68723 15.2344 3.00009C15.2344 4.31295 16.3025 5.38104 17.6153 5.38104C18.9282 5.38104 19.9963 4.31295 19.9963 3.00009C19.9963 1.68723 18.9282 0.619141 17.6153 0.619141Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIconBlack);
export default __webpack_public_path__ + "static/media/more-icon-black.177294b1cd363a7fd7b4f0dd38da6639.svg";
export { ForwardRef as ReactComponent };